import { handleActions } from 'redux-actions';

import { getResult } from 'shared/redux/helpers/normalized';
import { excludeVideoIdsFromPrams, replaceIds } from 'shared/redux/helpers/ids';
import { isFake } from 'shared/utils/video-helpers/statuses';

import { NAMES as SERVER_VIDEOS_LIST } from 'dashboard/redux/server/actions/videos/list';
import { NAMES as SERVER_VIDEOS_SEARCH } from 'dashboard/redux/server/actions/videos/search';
import { NAMES as SERVER_VIDEOS_REMOVE } from 'dashboard/redux/server/actions/videos/remove';
import { NAMES as SERVER_VIDEOS_CREATE } from 'dashboard/redux/server/actions/videos/create';
import { NAMES as CLIENT_VIDEOS_REMOVE } from 'dashboard/redux/client/actions/videos/remove';
import { NAMES as SERVER_VIDEO_UPLOAD } from 'dashboard/redux/server/actions/video/upload';


function responseWithFakeIds(state, { payload }) {
  const { result } = payload.response.data;
  const fakeIds = _.filter(state, id => isFake({ id }));
  return _.uniq([...fakeIds, ...result]);
}

function prependResult(state, { payload }) {
  const { result } = payload.response.data;
  return _.uniq([..._.castArray(result), ...state]);
}

function replaceIdsFromParamsWithResult(state, { payload }) {
  const ids = _.map(_.castArray(payload.params), 'id');
  const result = _.castArray(payload.response.data.result);

  return _.uniq(replaceIds(state, ids, result));
}


export default handleActions({
  [SERVER_VIDEOS_LIST.SUCCESS]: responseWithFakeIds,
  [SERVER_VIDEOS_SEARCH.SUCCESS]: getResult,

  [CLIENT_VIDEOS_REMOVE.SUCCESS]: excludeVideoIdsFromPrams,

  [SERVER_VIDEOS_REMOVE.START]: excludeVideoIdsFromPrams,

  [SERVER_VIDEO_UPLOAD.START]: prependResult,
  [SERVER_VIDEOS_CREATE.START]: prependResult,

  [SERVER_VIDEO_UPLOAD.ITEM_CREATED]: replaceIdsFromParamsWithResult,
  [SERVER_VIDEOS_CREATE.ITEM_CREATED]: replaceIdsFromParamsWithResult,
}, []);



// WEBPACK FOOTER //
// ./src/shared/redux/client/reducers/videos/ids.js